import { objectSchemaOf, Joi, actionCreator } from '../helpers';

export const PONG = 'APPS/PONG';

export const pongPayloadSchema = objectSchemaOf<IPongPayload>({
  id: Joi.string().required(),
  timestamp: Joi.number().required(),
});

export const pongActionSchema = objectSchemaOf<IPongAction>({
  type: Joi.string().required().valid(PONG),
  payload: pongPayloadSchema.required(),
});

export interface IPongPayload {
  id: string;
  timestamp: number;
}

export interface IPongAction {
  type: typeof PONG;
  payload: IPongPayload;
}

export const pong = actionCreator({
  type: PONG,
  schema: pongActionSchema,
});
